import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '⚡',
  title: "Lezioni Pronte all'Uso",
  desc: 'Tutto strutturato per ragazzi dagli 11 ai 19 anni. Apri il file e sei pronto per il laboratorio.'
}, {
  icon: '📚',
  title: 'Soluzionari Completi',
  desc: 'Ogni esercizio di Python, HTML e CSS già risolto e commentato passo dopo passo.'
}, {
  icon: '🖥️',
  title: 'Slide LIM Incluse',
  desc: 'Slide grafiche pronte da proiettare per rendere chiari anche i concetti più astratti.'
}, {
  icon: '🎓',
  title: 'Conforme MIUR',
  desc: 'Copertura completa del piano di studi con progetti allineati al DigComp 2.2.'
}, {
  icon: '♿',
  title: 'DSA e BES Inclusi',
  desc: 'Materiali differenziati per livello e schede per studenti con bisogni educativi speciali.'
}, {
  icon: '📝',
  title: 'Verifiche e Griglie Pronte',
  desc: 'Verifiche modulari con rubriche conformi alle linee guida ministeriali.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-21">
      <div className="max-w-xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-23">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-24">
            Cosa otterrai con{' '}
            <span className="text-brand-orange" data-id="element-25">Programmazione Pronta.</span>
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-26">
            6 vantaggi concreti che trasformano il modo in cui prepari, insegni
            e valuti l'informatica.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 mb-6" data-id="element-27">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-brand-orange/20 p-5 rounded-2xl hover:border-brand-orange/50 transition-colors" data-id="element-28">
              <div className="flex items-start gap-3" data-id="element-29">
                <div className="text-3xl shrink-0" data-id="element-30">{b.icon}</div>
                <div data-id="element-31">
                  <h3 className="text-lg font-bold text-brand-gold mb-1" data-id="element-32">
                    {b.title}
                  </h3>
                  <p className="text-gray-300 text-sm font-medium leading-snug" data-id="element-33">
                    {b.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-sm text-brand-orange font-bold" data-id="element-34">
          4 Bonus esclusivi inclusi gratuitamente.
        </p>
      </div>
    </section>;
}